import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import { Card } from 'react-bootstrap';
//import './RadarChartStyles.css';

const RadarChart = ({ rating = 5 }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (!chartRef.current) return;
        const ctx = chartRef.current.getContext('2d');

        // Destruir la instancia anterior del gráfico si existe
        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        chartInstance.current = new Chart(ctx, {
            type: 'radar',
            data: {
                labels: ['Nutrition', 'Safety', 'Natural', 'Processing', 'Additives'],
                datasets: [{
                    label: 'Score',
                    data: [
                        rating,
                        rating * 0.8 + 2,
                        8, // Asuming fixed value for 'Natural'
                        6, // Asuming fixed value for 'Processing'
                        5  // Asuming fixed value for 'Additives'
                    ],
                    backgroundColor: 'rgba(59, 130, 246, 0.2)',
                    borderColor: 'rgba(59, 130, 246, 1)',
                    borderWidth: 2,
                    pointBackgroundColor: 'rgba(59, 130, 246, 1)',
                }]
            },
            options: {
                responsive: true,
                scales: {
                    r: {
                        min: 0,
                        max: 10,
                        ticks: {
                            stepSize: 2,
                            backdropColor: 'transparent',
                        },
                        grid: {
                            color: '#e5e7eb',
                        },
                        angleLines: {
                            color: '#d1d5db',
                        },
                        pointLabels: {
                            color: '#374151',
                            font: {
                                size: 12
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            }
        });

        return () => {
            // Cleanup chart instance on component unmount
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [rating]);

    return (
        <Card className="radar-chart-card shadow-sm mb-4">
            <Card.Header className="radar-chart-header">
                <h4 className="mb-0">
                    <span className="chart-icon">📊</span> Nutritional Profile
                </h4>
            </Card.Header>
            <Card.Body className="text-center">
                <div className="chart-container">
                    <canvas ref={chartRef}></canvas>
                </div>
            </Card.Body>
        </Card>
    );
};

export default RadarChart;
